import { render, staticRenderFns } from "./pc-side-product.vue?vue&type=template&id=c6b26100&"
import script from "./pc-side-product.vue?vue&type=script&lang=js&"
export * from "./pc-side-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports